import {Component, inject, signal} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {environment} from "src/app/environments/environment";
import {PushNotificationService} from "src/app/infrastructure/push-notification.service";
import {appVersion} from "src/app/app-info";
import {GenericButtonComponent} from "src/app/presentation/common/generic-button/generic-button.component";
import {Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {InitService} from 'src/app/infrastructure/init/init.service';
import {AuthenticationService} from 'src/app/application/authentication/authentication.service';

@Component({
  selector: 'app-login',
  imports: [
    NgbModule,
    FormsModule,
    GenericButtonComponent
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {

  uid = signal<string | undefined>(undefined);
  password = signal<string | undefined>(undefined);
  loading = signal(false);
  errorMessage = signal<string | undefined>(undefined);

  protected readonly environment = environment;
  protected readonly appVersion = appVersion;

  private router = inject(Router);

  constructor(
    private authenticationService: AuthenticationService,
    private initService: InitService,
    private notificationService: PushNotificationService
  ) {}

  async signIn() {
    this.errorMessage.set(undefined);

    const uid = this.uid();
    const password = this.password();

    if (!uid || !password) return;

    this.loading.set(true);

    try {
      await this.authenticationService.authenticateUser(uid.trim(), password.trim());

      this.router.navigate(['/main/information-center']);
      this.initService.setUpApp();

      await this.notificationService.registerForPushNotifications();
    } catch (error) {
      console.error('Unexpected error while logging in', error);

      this.loading.set(false);
      this.password.set(undefined);

      if (error instanceof HttpErrorResponse && error.status === 403) {
        this.errorMessage.set("This combination of username and password is invalid.");
      } else if (error instanceof HttpErrorResponse) {
        this.errorMessage.set(`An unexpected error occurred with status ${error.status}. Please try again.`);
      } else {
        this.errorMessage.set(`An unexpected error occurred. Please try again.`);
      }
    }
  }
}
